<script setup lang="ts">
import QuickAccessItem from './QuickAccessItem.vue';
import { LandingContentsQuickAccessLayoutEnum } from '@clients/ContentApi';
const { landingPageContents } = useContentStore();
const layout = computed(() => {
    switch (landingPageContents?.quickAccessLayout) {
        case LandingContentsQuickAccessLayoutEnum.Column:
            return 'column';
        case LandingContentsQuickAccessLayoutEnum.DoubleRow:
            return 'double-row';
        case LandingContentsQuickAccessLayoutEnum.SingleRow:
            return 'single-row';
        default:
            return 'double-row';
    }
});
</script>
<template>
    <div :class="['quick-access-container', layout]">
        <QuickAccessItem
            v-for="access in landingPageContents?.quickAccessItems"
            :key="access.id"
            :title="access.Title"
            :color="access.Color"
            :icon="access.Icon"
            :description="access.Description || ''"
            :link="access.Link"
        />
    </div>
</template>

<style lang="scss" scoped>
.quick-access-container {
    display: grid;
    padding: 16px 0;
    overflow-x: auto;
    &.single-row {
        grid-auto-flow: column dense;
    }
    &.double-row {
        grid-template-rows: auto auto;
        grid-auto-columns: auto;
        grid-auto-flow: column dense;
    }
    @include mobile-only {
        padding: 8px;
    }
}
</style>
